import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logoLight from "assets/images/logo-light.png";
import logoDark from "assets/images/logo-dark.png";
import { useTranslation } from "react-i18next";
import { BasicInput } from "../UI";
import { Loader2, MoveRight } from "lucide-react";

interface ResetPasswordProps {
  formik: any;
}

export const ResetPassword: React.FC<ResetPasswordProps> = ({ formik }) => {
  document.title = "Create Password | POS - Point of Sale: Carnet";

  const { t } = useTranslation();

  useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className="relative pt-14 h-full">
        {/* <AuthIcon /> */}

        <div className="mb-0 w-screen lg:w-[500px] card shadow-lg border-none shadow-slate-100 dark:shadow-zink-500/20 relative">
          <div className="!px-10 !py-12 card-body">
            <Link to="/">
              <img
                src={logoLight}
                alt=""
                className="hidden h-6 mx-auto dark:block"
              />
              <img
                src={logoDark}
                alt=""
                className="block h-6 mx-auto dark:hidden"
              />
            </Link>

            <div className="mt-8 text-center">
              <h4 className="mb-2 text-custom-500 dark:text-custom-500">
                {t("registerScreen.title")}
              </h4>
              <p className="mb-8 text-slate-500 dark:text-zink-200">
                {t("registerScreen.disclaimer")}
              </p>
            </div>

            <form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              <BasicInput
                label={t("registerScreen.inputcurrentPassword")}
                placeholder={t(
                  "registerScreen.inputcurrentPasswordPlaceholder"
                )}
                id="currentPassword"
                name="currentPassword"
                type="password"
                value={formik.values.currentPassword}
                isError={
                  formik.touched.currentPassword &&
                  formik.errors.currentPassword
                }
                errorMessage={formik.errors.currentPassword}
                onChange={(e) =>
                  formik.setFieldValue("currentPassword", e.target.value)
                }
                onBlur={formik.handleBlur}
              ></BasicInput>
              <BasicInput
                label={t("registerScreen.inputPasswordLabel")}
                placeholder={t("registerScreen.inputPasswordPlaceholder")}
                id="password"
                name="password"
                type="password"
                value={formik.values.password}
                isError={formik.touched.password && formik.errors.password}
                errorMessage={formik.errors.password}
                onChange={(e) =>
                  formik.setFieldValue("password", e.target.value)
                }
                onBlur={formik.handleBlur}
              ></BasicInput>
              <BasicInput
                label={t("registerScreen.confirmPasswordLabel")}
                placeholder={t("registerScreen.inputPasswordPlaceholder")}
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                value={formik.values.confirmPassword}
                isError={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                }
                errorMessage={formik.errors.confirmPassword}
                onChange={(e) =>
                  formik.setFieldValue("confirmPassword", e.target.value)
                }
                onBlur={formik.handleBlur}
              ></BasicInput>
              <div className="mt-8">
                <button
                  type="submit"
                  className="w-full flex flex-row justify-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  //onClick={formik.handleSubmit}
                  data-action="next"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? (
                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                  ) : null}
                  {t("registerScreen.btnResetPassword")}
                  <MoveRight className="inline-block h-4 ml-1 rtl:rotate-180" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
